// extracted by mini-css-extract-plugin
export var clickBlocker = "_ks-c";
export var interactivePassthrough = "_ks-4";
export var lookHere = "_ks-3";
export var modal = "_ks-e";
export var modalBackdrop = "_ks-d";
export var modalBody = "_ks-p";
export var modalBodyHero = "_ks-q";
export var modalDescription = "_ks-s";
export var modalEnter = "_ks-f";
export var modalFooter = "_ks-t";
export var modalFooterHero = "_ks-u";
export var modalHeaderText = "_ks-n";
export var modalHeroImage = "_ks-i";
export var modalHeroTitle = "_ks-l";
export var modalIconCircle = "_ks-o";
export var modalIconHeader = "_ks-m";
export var modalImageLabel = "_ks-k";
export var modalImageOverlay = "_ks-j";
export var modalImageWrapper = "_ks-h";
export var modalTitle = "_ks-r";
export var modalWithHero = "_ks-g";
export var pulse = "_ks-1";
export var pulseBorder = "_ks-2";
export var spotlight = "_ks-0";
export var tooltip = "_ks-5";
export var tooltipButtons = "_ks-a";
export var tooltipDescription = "_ks-7";
export var tooltipFooter = "_ks-8";
export var tooltipInteractiveHint = "_ks-b";
export var tooltipStepIndicator = "_ks-9";
export var tooltipTitle = "_ks-6";